import React, { useContext } from 'react';
import ConteinerList from '../../components/ConteinerList';
import Header from '../../components/Header';
import { UserContexts } from '../../Context/UserContexts';
import { Conteiner, DivName } from './styles';
import ConteinerNovasTech from '../../components/ConteinerCadastro';
import { Navigate } from 'react-router-dom';


function Dashboard() {
  const { loading, name, modulo, open} = useContext(UserContexts)

  if(loading){
    return<div>Carregando...</div>;
  }
  
  return ( name ?
    
    <Conteiner>
  <Header></Header>
    <DivName>
    <h2>{`Ola ${name}`}</h2>
    <p>{modulo}</p>
    </DivName>
    {open && <ConteinerNovasTech/>}
    <ConteinerList/>
    </Conteiner> :
    <Navigate to="/login" replace />
  );
  
}

export default Dashboard;